import React from 'react';
import { Card, Row, Col } from 'antd';

interface IComponentProps {
	data?: any;
  enums?: any;
}

const BaseInfo:React.FC<IComponentProps> = (props) => {
  const { data, enums } = props || {};
  const { order_code, order_status, create_time, cancel_time } = data?.order_info || {};
  const { total_amount, refund_amount, deduct_amount } = data?.order_info?.bill_info || {};
  const { f_order_status } = enums || {};

  const orderStatusText = (f_order_status || []).find((item: any) => item.key === order_status)?.value;

  const getDefaultText = (text: string) => {
    return text || '--';
  }

  return (
    <>
      <Card title="基本信息" style={{ marginBottom: 20 }}>
        <Row style={{ marginBottom: 12 }}>
          <Col span={2}>订单编号:</Col><Col span={4} style={{ wordWrap: 'break-word' }}>{getDefaultText(order_code)}</Col>
          <Col span={2}>订单状态:</Col><Col span={4}><span style={{ color: '#FF6400' }}>{getDefaultText(orderStatusText)}</span></Col>
          <Col span={2}>下单时间:</Col><Col span={4}>{getDefaultText(create_time)}</Col>
          <Col span={2}>取消时间:</Col><Col span={4}>{getDefaultText(cancel_time)}</Col>
        </Row>
        <Row style={{ marginBottom: 12 }}>
          <Col span={2}>订单总金额:</Col><Col span={4}>{(total_amount / 100) || 0}元</Col>
          <Col span={3}>主单取消退款金额:</Col><Col span={3}>{(refund_amount / 100) || 0}元</Col>
          <Col span={2}>主单取消扣费:</Col><Col span={4}>{(deduct_amount / 100) || 0}元</Col>
          {/* <Col span={2}>订单优惠金额:</Col><Col span={4}>{(original_amount - total_amount) || 0}</Col>
          <Col span={2}>订单实付金额:</Col><Col span={4}>{total_amount || 0}</Col> */}

        </Row>
      </Card>
    </>
  );
}

export default BaseInfo;
